import React, { CSSProperties } from 'react';
import { BoxSectionContainer } from './styles';

export interface IBoxSectionProps {
  level?: 'content' | 'wrapper';
  children: React.ReactNode;
  style?: CSSProperties;
}

const BoxSection = ({
  children,
  level = 'content',
  style,
}: IBoxSectionProps) => {
  return (
    <BoxSectionContainer level={level} style={style}>
      {children}
    </BoxSectionContainer>
  );
};

export default BoxSection;
